import Link from 'next/link';

import { Icons } from '@/components/icons';

import SidebarItem from './sidebar-item';
import { infoData, sidebarData } from './data';

const Sidebar = () => {
  return (
    <aside className='fixed top-0 left-0 h-full w-[264px] hidden lg:flex flex-col justify-between border-r-2 border-border-primary bg-gray-700 z-40'>
      <nav className='flex flex-col justify-between h-full py-10 px-8 '>
        <div className='flex flex-col gap-[60px]'>
          <Icons.logo />
          <div className='flex flex-col'>
            {sidebarData.map((sidebarItem, index) => (
              <SidebarItem key={index} {...sidebarItem} />
            ))}
          </div>
        </div>
      </nav>
      <div className='py-5 px-8 border-t-2 border-border-primary'>
        <div className='flex items-center justify-between'>
          {infoData.map((info, index) => (
            <Link
              href={info.href}
              target='_blank'
              id={info.name}
              key={index}
              className='p-2 bg-button-secondary hover:bg-button-secondary-hover active:bg-button-secondary-pressed rounded-10 transition-colors text-text-primary hover:text-white'
            >
              {info.icon}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
